import { parseISO } from 'date-fns/parseISO';

type IParseDateString = (dateString: string) => Date;

/**
 * 'YYYY-MM-DD' 形式などの ISO 8601 の日付文字列を Date に変換する
 *
 * new Date('YYYY-MM-DD') は UTC 0 時として解釈され、負のオフセットのタイムゾーンでは前日にずれるため、
 * parseISO でローカル日付として解釈する。解釈できない文字列の場合は Invalid Date を返す
 */
export const parseDateString: IParseDateString = dateString => parseISO(dateString);
